//////////////////////////////////////////////
//! page();
//////////////////////////////////////////////

var page = {

	current: '',
	uiLoaded: false,
	pageLoaded: false,
	viewed:{
		home:false,
		gallery:false,
		videos:false,
		feature:false,
	},
	
//////////////////////////////////////////////
//! page.checkUrl();
//////////////////////////////////////////////

	//Check the URL for #hash
	checkHash:function(hash){debug('page.checkUrl '+hash);
		//alert('check url');
		
		//Get Hash from Addressbar
		if(!hash) {hash=window.location.hash;} //Deeplinking for address bar
		
		//Check if actual current against stored current
		if (hash !== page.current) { 
			
			location.hash = hash;//update the hash
			page.current = hash.replace('#','');//Update stored current
			
			page.fetch(hash);//run loader using current page
		}
		
		//Check if currentPage is undefined (new visiter to root index.php)
		else if(page.current === "") { 
			//alert('check url - NO HASH');
			location.hash = '#home';//Load the default page
		
		}
	},

//////////////////////////////////////////////
//! page.fetch()
//////////////////////////////////////////////
	
	//Fetch the correct page
	fetch:function(url) { debug('page.feth '+url);
		
		//srip out the #
		url= url.replace('#','');
		
		//Check page exists (if not fall back to #home)
		if ( $('#js-page-'+url).length === 0 ){
			
			page.checkHash('#home');
		}
		
		
		//If new visite to the site 
		else if (!page.uiLoaded) {
			
			page.ui(url);
			page.updateMenu(url);
		}
		
		
		
		//Normal page Change
		else {
			
			page.swap(url);
			page.updateMenu(url);
		}
		
	},

//////////////////////////////////////////////
//! page.updateMenu()
//////////////////////////////////////////////
	
	//Update menu items current status
	updateMenu:function(currentPage){
		
		$('body').attr('id', currentPage);
		
		//Cycyle the meu items		
		$('#js-mainMenu li, #js-menuPanal li').each(function(){
			
			//Get rid of 'current' classes
			$(this).removeClass('is-current');
			
			//Check against current page
			if ($(this).attr('id') == currentPage ) {
				
				//Add 'current' class to current page
				$(this).addClass('is-current');
			}
		});
		
	},

//////////////////////////////////////////////
//! page.showUi
//////////////////////////////////////////////
	
	//Show the UI elements
	ui:function(currentPage) {
		
		//Check if the trailer needs to be loaded
		if (currentPage === "home" && !ytPlayer.trailerWatched && app.settings.showTrailer) {
			
			//Open the overlay (as this is a new visit the trailer is already preloaded.
			ytPlayer.overlayOpen();
		
		//normal UI Load
		} else {
			
			//On mobiles we need to load the footer at the same time as the pag contents to avoid jumping
			if (Detectizr.device.type === 'mobile') {
				//Animate elemnts
				$('#js-menuBar').animate({
					opacity: 1
				},app.settings.pageSpeed);
				
				//animate the page contents...
				setTimeout(function(){
					$('.site-footer').animate({
						opacity: 1
					},app.settings.pageSpeed);
					page.show(currentPage);
				}, app.settings.pageSpeed);
			} 
			
			else{
				//Animate elemnts
				$('#js-menuBar, .site-footer').animate({
					opacity: 1
				},app.settings.pageSpeed);
				
				//animate the page contents...
				setTimeout(function(){
					page.show(currentPage);
				}, app.settings.pageSpeed);
			}
			
			//Track ui as loaded
			page.uiLoaded = true;
			
			//On desktop begin the audio
			if (Detectizr.device.type === 'desktop') {
				
				
			}
		}
		
	},

//////////////////////////////////////////////
//! page.show()
//////////////////////////////////////////////
	
	//show selected page
	show:function(currentPage) {
		
		//show page
		$('#js-page-'+currentPage).show();
		
	
		
		//Animate in page (background image)
		
		if (page.current === 'home' && !page.viewed.home) {
			
			parallax.initPlax();
			
		} else if (page.current === 'home') {
			
			parallax.addEvents();
		}
		
		$('#js-page-'+currentPage).animate({
			opacity: 1
		},app.settings.pageSpeed, function(){
			
			//animate in page components (contents)
			$('#js-page-'+currentPage+', .page__article').animate({
				opacity: 1
			}, app.settings.pageSpeed);
			
		});
		
		page.pageLoaded = true;
		
		
		//Trigger pageEvents
		setTimeout(function(){
			app.pageEvents();
			page.viewed[currentPage] = true;//set the page to viewed
		}, app.settings.pageSpeed*2);
		
	},

//////////////////////////////////////////////
//! page.hide()
//////////////////////////////////////////////
	
	//Hide a page
	hide:function() {
		
		parallax.removeEvents();
		
		//Animate out
		$('.js-page, .page__article, .slick-slider').animate({
			opacity: 0
		}, app.settings.pageSpeed);
		
		//Hide the page
		setTimeout(function(){
			$('.js-page').hide();
		}, app.settings.pageSpeed);
		
		page.pageLoaded = false;
	},

//////////////////////////////////////////////
//! page.swap()
//////////////////////////////////////////////
	
	swap:function(nextPage) {
		
		//Hide current page
			page.hide();
			
		//Check if trailer needs to be loaded
		if (nextPage == 'home' && !ytPlayer.trailerWatched && app.settings.showTrailer) {
			
			//Wait whilst page closes
			setTimeout(function(){
				
				//Show the trailer
				ytPlayer.show('trailer');
			}, app.settings.pageSpeed);
		
		//Normal Page.swap
		} else {
			
			//Wait whilst page closes
			setTimeout(function(){
				
				//Show the next page
				page.show(nextPage);
			}, app.settings.pageSpeed);
		}
		
		
	},

};